import { Navigate, Route, Routes } from 'react-router-dom';
import { Sidebar } from './components/Sidebar';
import HomePage from './pages/HomePage';
import GroupsWorkspace from './pages/GroupsWorkspace';
import ClientWorkspace from './pages/ClientWorkspace';
import EnterpriseReporting from './pages/EnterpriseReporting';
import ModelWorkspace from './pages/ModelWorkspace';
import StaffPlanWorkspace from './pages/StaffPlanWorkspace';
import SpendSetWorkspace from './pages/SpendSetWorkspace';
import ToastViewport from './components/Toast';
import AuthGate from './components/AuthGate';

export default function App() {
  return (
    <AuthGate>
      {(user, onLogout) => {
        const isPlatformAdmin = user.permissions.canAccessModelsAndReporting;
        const defaultPath = isPlatformAdmin ? '/' : '/geoclients';

        return (
          <div className="flex h-full">
            <Sidebar user={user} onLogout={onLogout} />
            <main className="flex-1 overflow-y-auto">
              <Routes>
                <Route
                  path="/"
                  element={isPlatformAdmin ? <HomePage /> : <Navigate to="/geoclients" replace />}
                />
                <Route path="/geoclients" element={<GroupsWorkspace />} />
                <Route path="/groups" element={<Navigate to="/geoclients" replace />} />
                <Route path="/clients" element={<Navigate to="/geoclients" replace />} />
                <Route path="/clients/:clientId" element={<ClientWorkspace user={user} />} />
                <Route
                  path="/clients/:clientId/scenarios/:scenarioId"
                  element={<ClientWorkspace user={user} />}
                />
                <Route
                  path="/clients/:clientId/staff-plans/:planId"
                  element={<StaffPlanWorkspace user={user} />}
                />
                <Route
                  path="/clients/:clientId/spend-sets/:spendSetId"
                  element={<SpendSetWorkspace user={user} />}
                />
                <Route
                  path="/models"
                  element={isPlatformAdmin ? <ModelWorkspace /> : <Navigate to="/geoclients" replace />}
                />
                <Route
                  path="/models/:modelId"
                  element={isPlatformAdmin ? <ModelWorkspace /> : <Navigate to="/geoclients" replace />}
                />
                <Route
                  path="/reporting"
                  element={
                    isPlatformAdmin ? <EnterpriseReporting /> : <Navigate to="/geoclients" replace />
                  }
                />
                <Route path="/admin/*" element={<Navigate to={defaultPath} replace />} />
                <Route path="*" element={<Navigate to={defaultPath} replace />} />
              </Routes>
            </main>
            <ToastViewport />
          </div>
        );
      }}
    </AuthGate>
  );
}
